export default "__VITE_ASSET__BQ4SZpZB__"